export const scrollToSection = (sectionId: string, offset: number = 80) => {
  // Remove the # if it exists
  const id = sectionId.startsWith('#') ? sectionId.slice(1) : sectionId;
  
  const scrollToElement = () => {
    const element = document.getElementById(id);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      return true;
    }
    return false;
  };

  // Try to scroll immediately
  if (scrollToElement()) {
    return;
  }

  // If element not found, wait for DOM updates and try again
  const observer = new MutationObserver(() => {
    if (scrollToElement()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Stop observing after 3 seconds to prevent memory leaks
  setTimeout(() => {
    observer.disconnect();
  }, 3000);
};

export const handleAnchorLink = (to: string, navigate: (path: string) => void) => {
  const [path, hash] = to.split('#');
  const currentPath = window.location.pathname;

  if (path === currentPath && hash) {
    // Same page navigation - just scroll
    scrollToSection(hash);
  } else if (hash) {
    // Different page navigation - navigate then scroll
    navigate(path);
    // Wait for navigation and content loading
    setTimeout(() => {
      scrollToSection(hash);
    }, 100);
  } else {
    // No hash - normal navigation
    navigate(to);
  }
};